import React from 'react';

const ProfileWidget = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userEmail = user?.email || 'Not available';
    const userName = userEmail.split('@')[0];

    return (
        <div className="profile-container">
            <div className="profile-widget">
                <div className="profile-content">
                    <div className="avatar">
                        <div className="avatar-initial">
                            {userName[0]}
                        </div>
                    </div>
                    
                    <div className="user-info">
                        <span className="username">{userName}</span>
                        <span className="email">{userEmail}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileWidget;